import throttle from 'lodash.throttle'
import debounce from 'lodash.debounce'
import { lxPV, lxMC, lxMV, lxTag, lxTagMC } from './lx'
import { errorHandler } from './axios/response'

window.errorHandler = function (needToasted = true, needLogin = false) {
  return function (_target: any, _name: string, descriptor: PropertyDescriptor) {
    const fn = descriptor.value
    descriptor.value = async function (...args: any[]) {
      try {
        return await fn.apply(this, args)
      } catch (err) {
        errorHandler(err, { needToasted, needLogin })
      }
    }
  }
}

window.lx = function (action: string, ...args: (string | Function)[]) {
  return function (_target: any, _name: string, descriptor: PropertyDescriptor) {
    const fn = descriptor.value
    descriptor.value = async function (...argsfn: any[]) {
      // console.log('@lx')
      const lxApis: Record<string, Function> = { lxPV, lxMC, lxMV, lxTag, lxTagMC }
      const lxArgs = args.map((arg: string | Function) => {
        if (typeof arg === 'function') {
          arg = arg(this, ...argsfn)
        }
        return arg
      })
      const lxfn = lxApis['lx' + action.toUpperCase()]
      lxfn && lxfn(...lxArgs)
      return fn.apply(this, argsfn)
    }
  }
}

window.throttle = function (time: number) {
  return function (_target: any, _name: string, descriptor: PropertyDescriptor) {
    const fn = descriptor.value
    descriptor.value = throttle(
      function (...argsfn) {
        console.log('throttle')
        // @ts-expect-error 不会写
        return fn.apply(this, argsfn)
      },
      time,
      {
        trailing: false,
      },
    )
  }
}

window.debounce = function (time: number) {
  return function (_target: any, _name: string, descriptor: PropertyDescriptor) {
    const fn = descriptor.value
    descriptor.value = debounce(function (...argsfn) {
      console.log('debounce')
      // @ts-expect-error 不会写
      return fn.apply(this, argsfn)
    }, time)
  }
}

declare global {
  interface Window {
    lx: Function
    errorHandler: Function
    throttle: Function
    debounce: Function
  }
}
